import { render } from "./ViewedFiles.vue?vue&type=template&id=6751091e"
import script from "./ViewedFiles.vue?vue&type=script&lang=ts"
export * from "./ViewedFiles.vue?vue&type=script&lang=ts"
script.render = render

export default script